import { listOrganizations } from '@dealstack/frontend/shared/dataExchange/services/organization.api';
import { OrganizationListRes } from '@dealstack/shared/lib/generated';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

interface Params {
	page: number;
	limit: number;
	search?: string;
}

const emptyPage = (params: Params): OrganizationListRes => ({
	rows: [],
	total: 0,
	page: params.page,
	limit: params.limit,
});

export const useOrganizations = (params: Params, options?: { enabled?: boolean }) => {
	return useQuery({
		queryKey: [API_PATHS.ORGANIZATION_GET, params.page, params.limit, params.search ?? ''],
		queryFn: async () => {
			const result = await listOrganizations(params);
			return result.payload ?? emptyPage(params);
		},
		placeholderData: keepPreviousData,
		...options,
	});
};
